import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q3/2023gygg/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};
// 人物
const vote = (page: number, search: string, type: number) => {
  return http.get(
    `${urlPrefix}vote-list&search=${search}&page=${page}&type=${type}`,
  );
};
const voteDetail = (id: string) => {
  return http.get(
    `${urlPrefix}detail&id=${id}`,
  );
};
const getRules = () => {
   return http.get(
    `${urlPrefix}rules`,
  );
};
export {
  getBaseInfo,
  getNews,
  vote,
  voteDetail,
  getRules,
};
